// extracted by mini-css-extract-plugin
export default {"buttons":"cart-modal_buttons__rO2-S"};